import { useRef, useState } from 'react';

const useCountDown = (initialTimer: number) => {
  const [counter, setCounter] = useState(initialTimer);
  const [isCounterFinished, setIsCounterFinished] = useState(false);
  const counterIntervalRef = useRef<any>(null);
  const minuteTimer = new Date(counter * 1000).toISOString().substring(14, 19);
  const resetTimer = () => {
    setCounter(initialTimer);
    clearInterval(counterIntervalRef.current!);
    setIsCounterFinished(false);
  };
  const startTimer = () => {
    resetTimer();
    counterIntervalRef.current = setInterval(() => {
      setCounter((prevState) => {
        const newCount = prevState - 1;
        if (newCount === 0) {
          clearInterval(counterIntervalRef.current!);
          setIsCounterFinished(true);
        }
        return newCount;
      });
    }, 1000);
  };

  return { startTimer, counter, isCounterFinished, minuteTimer, resetTimer };
};

export default useCountDown;
